import { Container, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import BaseLink from "../../components/BaseLink";

export default function PageNotFound() {
  return (
    <Wrapper>
      <Typography
        variant="h5"
        color='darkGray'
        sx={{
          fontSize: { xs: '24px', sm: '40px' },
        }}
      >
        SORRY, THAT PAGE DOESN’T EXIST!
      </Typography>
      <Typography
        color='darkGray'
        sx={{
          fontSize: { xs: '18px', sm: '20px' },
          marginTop: '20px'
        }}
      >
        WE COULDN&lsquo;T FIND THE PAGE YOU WERE LOOKING FOR.
      </Typography>
      <BaseLink 
        to='/'
        sx={{
          color: 'primary',
          marginTop: '20px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <HomeIcon color="primary" />
        <Typography
          sx={{
            fontSize: { xs: '18px', sm: '20px' },
            marginLeft: '5px'
          }}
        >
          Go Home
        </Typography>
      </BaseLink>
    </Wrapper>
  );
}

const Wrapper = styled(Container)`
  margin: 0 auto;
  padding: 150px 24px 24px;
  text-align: center;
`;
